import './index.css';
import { jsxs, jsx } from 'react/jsx-runtime';
import { createContext, useRef, useState, useMemo, useEffect } from 'react';
import { Cookies } from '@hh.ru/magritte-common-cookies';
import { useResize } from '@hh.ru/magritte-common-resize';

var styles = {"breakpoint-checker":"magritte-breakpoint-checker___EXzjN_5-0-0","breakpointChecker":"magritte-breakpoint-checker___EXzjN_5-0-0"};

var Breakpoint;
(function (Breakpoint) {
    Breakpoint["XS"] = "xs";
    Breakpoint["S"] = "s";
    Breakpoint["M"] = "m";
    Breakpoint["L"] = "l";
    Breakpoint["XL"] = "xl";
    Breakpoint["XXL"] = "xxl";
})(Breakpoint || (Breakpoint = {}));
const DEFAULT_BREAKPOINT = Breakpoint.XS;
const BreakpointContext = createContext({
    breakpoint: DEFAULT_BREAKPOINT,
    renderRestriction: false,
});
const detectBreakpointValue = (breakpointCheckerNode) => {
    if (!('getComputedStyle' in window)) {
        return DEFAULT_BREAKPOINT;
    }
    const style = window.getComputedStyle(breakpointCheckerNode);
    if (!style) {
        return DEFAULT_BREAKPOINT;
    }
    const value = style.getPropertyValue('font-family').replace(/['"]/g, '');
    if (!value) {
        return DEFAULT_BREAKPOINT;
    }
    return Object.values(Breakpoint).find((size) => size === value) || DEFAULT_BREAKPOINT;
};
const TWO_WEEKS_IN_HOURS = 24 * 14;
const BreakpointProvider = ({ children, storeActualBreakpointValueInCookie = false, storedBreakpointValue, force = false, renderRestriction = false, }) => {
    const breakpointCheckerNodeRef = useRef(null);
    const [breakpoint, setBreakpoint] = useState(storedBreakpointValue ?? DEFAULT_BREAKPOINT);
    const useOnlyStoredValue = !!(force && storedBreakpointValue);
    const contextValue = useMemo(() => ({
        breakpoint: useOnlyStoredValue ? storedBreakpointValue : breakpoint,
        renderRestriction,
    }), [breakpoint, renderRestriction, useOnlyStoredValue, storedBreakpointValue]);
    const sideEffect = () => {
        if (!useOnlyStoredValue && breakpointCheckerNodeRef.current) {
            const breakpoint = detectBreakpointValue(breakpointCheckerNodeRef.current);
            setBreakpoint(breakpoint);
            if (storeActualBreakpointValueInCookie) {
                Cookies.set('device_magritte_breakpoint', breakpoint, TWO_WEEKS_IN_HOURS);
            }
        }
    };
    useEffect(sideEffect, [useOnlyStoredValue, storeActualBreakpointValueInCookie]);
    useResize(sideEffect);
    return (jsxs(BreakpointContext.Provider, { value: contextValue, children: [children, jsx("div", { ref: breakpointCheckerNodeRef, className: styles['breakpoint-checker'] })] }));
};
BreakpointProvider.displayName = 'BreakpointProvider';

export { Breakpoint, BreakpointContext, BreakpointProvider as default };
//# sourceMappingURL=BreakpointProvider.js.map
